var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"treatment-link",on:{"click":function($event){return _vm.getLink()}}},[_vm._v(" "+_vm._s(_vm.$t('analysisRequests.labels.treatmentProgram'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }